import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: false
})
export class LogoComponent {
    @Input() fileId: string;
    @Input() editDisabled = false;
    @Input() fullView?: boolean = false;
    @Input() required?: boolean = true;
    @Output() logoChanged = new EventEmitter<string>();
    @ViewChild('logoUpload') logoUploadComponent: FileUploadComponent;

    imagePath(id: number): string {
        return `/proxy/api/v0/fileservice/file/${id}`;
    }

    removeLogo(): void {
        this.fileId = null;
        this.logoChanged.emit(null);
    }

    onLogoChanged(fileId: string): void {
        this.fileId = fileId;
        this.logoChanged.emit(this.fileId);
    }

    onDefaultContainerClick(): void {
        if (!this.editDisabled && this.logoUploadComponent) {
            this.logoUploadComponent.onUploadClicked();
        }
    }
}
